<template>
  <v-container>
    <v-layout row>
      <v-flex sm12 xs12 md12>
        <v-flex sm12 xs12 md12>
          <v-container>
            <v-card>
              <v-card-text>
                <v-layout row wrap style="padding: 10px 20px; background-color: #fff">
                  <v-flex xs10 sm10 md10>
                    <v-select
                      :items="filteredFieldTrackingUsers"
                      v-model="currentSelectedUser"
                      @change="selectUser()"
                      prepend-icon="supervisor_account"
                      label="Select User"
                      item-text="fullName"
                      item-value="id"
                      return-object
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="text-align: center; margin-top: 5px">
                    <v-menu :nudge-bottom="14" left style="margin-top: 12px">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" dark icon>
                          <v-icon class="black--text">more_vert</v-icon>
                        </v-btn>
                      </template>

                      <v-card class="elevation-0">
                        <v-card-text class="pa-0">
                          <v-list class="pa-0">
                            <!-- <v-list-item avatar @click="handleClick">
                                <v-list-item-avatar>
                                  <v-icon medium dark color="primary">cloud_download</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-subtitle>
                                    <download-excel
                                      :data="currentSelectedUser.fieldTrackings"
                                      :fields="exportFields"
                                      name="fieldTrackingReport.xls"
                                      >Download Field Report</download-excel
                                    >
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>-->

                            <v-list-item @click="exportInCSV" style="cursor: pointer">
                              <v-list-item-avatar>
                                <v-icon medium dark color="primary">get_app</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content>Download Field Report</v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout row wrap style="padding: 10px 20px; background-color: #fff">
                  <v-flex>
                    <div>
                      <full-datepicker @updateDate="updateDate"></full-datepicker>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-container>
        </v-flex>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12 sm12 md12 style="padding: 3px 15px">
        <v-container>
          <v-layout row wrap>
            <!-- map -->
            <v-flex xs12 sm8 md8>
              <v-card style="border-radius: 1px; padding: 0px">
                <vue-perfect-scrollbar class="white lighten-5">
                  <v-card-text style="border-radius: 1px; padding: 1px">
                    <GmapMap
                      ref="mapRef"
                      :center="center"
                      :zoom="7"
                      map-type-id="terrain"
                      style="min-width: 200px; min-height: 557px; width:100%"
                    >
                      <!-- All Realtime -->
                      <div v-if="currentSelectedUser.id == 'all' && isRealTimeEnable">
                        <GmapCustomMarker
                          v-for="(m, index) in _.filter(fieldTrackingUsers, f => {
                            return f.realtimeFieldTrackingSettings.enabled && f.lastSeen.gps;
                          })"
                          :key="index"
                          :marker="m.lastSeen.gps"
                          :clickable="true"
                          :draggable="false"
                          @click="center = latLng"
                          @change="center = latLng"
                        >
                          <div v-if="highlightedUser !== null">
                            <div v-if="highlightedUser.id == m.id">
                              <div class="marker_img_background">
                                <img
                                  :src="getImage(m.profilePicture, true)"
                                  class="marker_img_render"
                                />
                              </div>
                              <div class="pulse_ft"></div>
                            </div>
                            <div v-else class="marker_img_background">
                              <img
                                :src="getImage(m.profilePicture, true)"
                                class="marker_img_render"
                              />
                            </div>
                          </div>
                          <div v-else class="marker_img_background">
                            <img
                              :src="getImage(m.profilePicture, true)"
                              class="marker_img_render"
                            />
                          </div>
                        </GmapCustomMarker>
                      </div>

                      <!-- Fieldtracking -->
                      <div
                        v-if="currentSelectedUser.fieldTrackings.length > 0 && !isRealTimeEnable"
                      >
                        <GmapCustomMarker
                          v-for="(m, index) in currentSelectedUser.fieldTrackings"
                          :key="index"
                          :marker="m.gps"
                          :clickable="true"
                          :draggable="false"
                          @click="center = latLng"
                          @change="center = latLng"
                        >
                          <div v-if="highlightedUser !== null">
                            <div v-if="highlightedUser.id == m.id">
                              <div>
                                <img
                                  :src="require('@/assets/selected_pin.png')"
                                  alt
                                  class="selected_ft_marker_img_render"
                                />
                              </div>
                              <div class="pulse"></div>
                            </div>
                            <div v-else>
                              <img
                                :src="require('@/assets/ft.png')"
                                alt
                                class="ft_marker_img_render"
                              />
                            </div>
                          </div>
                          <div v-else>
                            <img
                              :src="require('@/assets/ft.png')"
                              alt
                              class="ft_marker_img_render"
                            />
                          </div>
                        </GmapCustomMarker>
                      </div>

                      <!-- start point -->
                      <div
                        v-if="
                          currentSelectedUser.realtimeFieldTrackingSettings.enabled &&
                            isRealTimeEnable &&
                            startTripPoint != {}
                        "
                      >
                        <GmapMarker
                          :clickable="true"
                          :draggable="false"
                          @click="center = latLng"
                          :icon="{
                            url: require('@/assets/st.png'),
                            size: { width: 40, height: 40, f: 'px', b: 'px' },
                            scaledSize: { width: 40, height: 40, f: 'px', b: 'px' }
                          }"
                          :position="startTripPoint"
                        ></GmapMarker>
                      </div>

                      <!-- Trip -->
                      <div
                        v-if="
                          currentSelectedUser.realtimeFieldTrackingSettings.enabled &&
                            isRealTimeEnable &&
                            currentTripMarker != {}
                        "
                      >
                        <GmapMarker
                          :clickable="true"
                          :draggable="false"
                          @click="center = latLng"
                          :icon="{
                            url: require('@/assets/trip.png'),
                            size: { width: 50, height: 50, f: 'px', b: 'px' },
                            scaledSize: { width: 50, height: 50, f: 'px', b: 'px' }
                          }"
                          :position="currentTripMarker"
                        ></GmapMarker>
                      </div>

                      <!-- Last Point -->
                      <div
                        v-if="
                          currentSelectedUser.realtimeFieldTrackingSettings.enabled &&
                            isRealTimeEnable &&
                            endTripPoint != {}
                        "
                      >
                        <GmapMarker
                          :clickable="true"
                          :draggable="false"
                          @click="center = latLng"
                          :icon="{
                            url: require('@/assets/lt.png'),
                            size: { width: 40, height: 40, f: 'px', b: 'px' },
                            scaledSize: { width: 40, height: 40, f: 'px', b: 'px' }
                          }"
                          :position="endTripPoint"
                        ></GmapMarker>
                      </div>

                      <!-- Last seen -->
                      <div
                        v-if="
                          currentSelectedUser.id != 'all' &&
                            typeof currentSelectedUser.lastSeen != 'undefined' &&
                            typeof currentSelectedUser.lastSeen.gps != 'undefined' &&
                            isRealTimeEnable
                        "
                      >
                        <GmapCustomMarker
                          :position="currentSelectedUser.lastSeen.gps"
                          :clickable="false"
                          :draggable="false"
                          :marker="currentSelectedUser.lastSeen.gps"
                        >
                          <div class="marker_img_background">
                            <img
                              :src="getImage(currentSelectedUser.profilePicture, true)"
                              class="marker_img_render"
                            />
                          </div>
                        </GmapCustomMarker>
                      </div>
                    </GmapMap>
                  </v-card-text>
                </vue-perfect-scrollbar>
              </v-card>
            </v-flex>

            <!-- Tab view -->
            <v-flex xs12 sm4 md4>
              <v-toolbar style="font-size: 14px;" tabs>
                <v-tabs v-model="tab" centered slider-color="white" background-color="primary" dark>
                  <v-tab @click.native="markedLocationClicked">Marked Location</v-tab>
                  <v-tab @click.native="isRealTimeEnable = true">
                    Real Time
                    <div class="betaDesign">Beta</div>
                  </v-tab>
                </v-tabs>
              </v-toolbar>

              <v-tabs-items v-model="tab" style="border-radius: 0px !important">
                <!-- FieldTracking Section -->
                <v-tab-item>
                  <div v-if="preloader" style="padding: 70px 50px; text-align: center;">
                    <v-progress-circular
                      :width="3"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                  <div v-else-if="'id' in currentSelectedUser">
                    <v-widget
                      v-if="currentSelectedUser.fieldTrackings.length > 0"
                      xs12
                      style="height: 410px; overflow-y: auto; border-top-left-radius: none; border-top-right-radius: none"
                    >
                      <div
                        slot="widget-content"
                        style="border-top-left-radius: 0px; border-top-right-radius: 0px"
                      >
                        <ol
                          v-for="(item, index) in currentSelectedUser.fieldTrackings"
                          :key="index"
                        >
                          <li @click="highlightPointer(item)" class="timeline-block">
                            <div class="timeline-point">
                              <v-avatar>
                                <v-img
                                  :src="getImage(item.image, true)"
                                  @click="zoom(item.image)"
                                ></v-img>
                              </v-avatar>

                              <v-btn
                                v-if="item.formResponseId != undefined"
                                @click="formResponseView(item)"
                                icon
                                ripple
                              >
                                <v-icon color="grey lighten-1">forum</v-icon>
                              </v-btn>
                            </div>
                            <div class="timeline-content">
                              <time datetime="2018" class="caption">
                                {{ timeFormat(item.time, "hours") }} ({{
                                  item.time | moment("timezone", item.timezone.name, "z")
                                }})
                              </time>
                              <div>{{ item.name }}</div>
                              <div>{{ item.address.display_name }}</div>
                              <div v-if="item.hotspotDetected != false">
                                <span v-if="item.hotspotDetected == 1" color="red"
                                  >🦠 Containment Zone</span
                                >
                                <span v-else-if="item.hotspotDetected == 2" color="red"
                                  >🦠 Red Zone</span
                                >
                                <span v-else-if="item.hotspotDetected == 5" color="green"
                                  >🦠 Green Zone</span
                                >
                                <span v-else color="yellow">🦠 Yellow Zone</span>
                              </div>
                            </div>
                          </li>
                        </ol>
                      </div>
                    </v-widget>
                    <div v-else style="padding: 60px 25px; text-align: center;">
                      <v-icon style="font-size: 50px; opacity: 0.7; margin-bottom: 20px"
                        >nature_people</v-icon
                      >
                      <h4 style="font-size: 14px; letter-spacing: 0.5px; font-weight: 400">
                        Currently, {{ currentSelectedUser.fullName }} has no marked location
                      </h4>
                    </div>
                  </div>
                  <div v-else style="padding: 40px 25px; text-align: center;">
                    <v-icon style="font-size: 60px; opacity: 0.6; margin-bottom: 20px"
                      >touch_app</v-icon
                    >
                    <h4
                      style="font-size: 16px; letter-spacing: 0.5px; font-weight: 400; opacity: 0.6"
                    >
                      Select a user for more details
                    </h4>
                  </div>
                </v-tab-item>

                <!-- Curent trip Section-->
                <v-tab-item>
                  <v-layout row>
                    <v-flex
                      v-if="currentSelectedUser.id != 'all'"
                      xs12
                      sm12
                      md12
                      style="padding: 0px 16px;"
                    >
                      <v-card
                        v-if="
                          currentSelectedUser.realtimeFieldTrackingSettings.enabled &&
                            'lastSeen' in currentSelectedUser
                        "
                        title="Last Seen"
                        content-bg="white"
                        style="border-radius: 0px; padding: 0px 15px"
                      >
                        <v-card-title>Current Trip</v-card-title>

                        <v-list v-if="'time' in currentSelectedUser.lastSeen" two-line class="pa-0">
                          <v-list-item href="#">
                            <v-list-item-action>
                              <v-icon color="indigo">access_time</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>Last Seen</v-list-item-title>
                              <v-list-item-subtitle>
                                {{
                                  currentSelectedUser.lastSeen.time
                                    | moment("timezone", currentSelectedUser.tz.name, "lll")
                                }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item v-if="'distance' in currentSelectedUser" href="#">
                            <v-list-item-action>
                              <v-icon color="indigo">motorcycle</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>Distance Travelled</v-list-item-title>
                              <v-list-item-subtitle>
                                {{ calculateDistance(currentSelectedUser.lastSeen.odo) }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-divider inset></v-divider>

                          <v-list-item
                            v-if="
                              'meta' in currentSelectedUser.lastSeen &&
                                'battery_level' in currentSelectedUser.lastSeen.meta
                            "
                            href="#"
                          >
                            <v-list-item-action>
                              <v-icon color="indigo">battery_charging_full</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>Battery Level</v-list-item-title>
                              <v-list-item-subtitle>
                                {{
                                  calculateBattery(currentSelectedUser.lastSeen.meta.battery_level)
                                }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-flex>

                    <!-- All members -->
                    <v-flex
                      v-show="currentSelectedUser.id == 'all'"
                      xs12
                      sm12
                      md12
                      style="padding: 0px 16px;"
                    >
                      <v-card content-bg="white" elevation="0" style="border-radius: 0px;">
                        <v-card-title>Current Members</v-card-title>

                        <v-list two-line class="pa-0">
                          <v-list-item
                            v-for="item in _.filter(fieldTrackingUsers, f => {
                              return f.realtimeFieldTrackingSettings.enabled;
                            })"
                            :key="item.id"
                            href="#"
                          >
                            <v-list-item-action>
                              <v-icon color="indigo">access_time</v-icon>
                            </v-list-item-action>

                            <v-list-item-avatar @click="selectUser(item)">
                              <v-avatar size="36px" color="primary">
                                <img
                                  v-if="item.profilePicture"
                                  :src="getImage(item.profilePicture, true)"
                                />

                                <span v-else class="white--text headline">
                                  {{ item.firstName.substring(0, 1) }}
                                </span>
                              </v-avatar>
                            </v-list-item-avatar>

                            <v-list-item-content @click="selectUser(item)">
                              <v-list-item-title
                                >{{ item.firstName }} {{ item.lastName }}</v-list-item-title
                              >
                              <v-list-item-subtitle v-if="item.lastSeen && item.lastSeen.time">
                                {{ item.lastSeen.time | moment("timezone", item.tz.name, "lll") }}
                                ({{ item.lastSeen.time | moment("timezone", item.tz.name, "z") }})
                              </v-list-item-subtitle>
                              <v-list-item-subtitle v-if="item.distance">
                                {{ item.distance }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action @click="trackLoc(item)">
                              <v-btn icon>
                                <v-icon color="grey lighten-1">notification_important</v-icon>
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-flex>

                    <!-- Records per user -->
                    <v-flex
                      v-show="currentSelectedUser.id != 'all'"
                      xs12
                      sm12
                      md12
                      style="padding: 0px 14px;"
                    >
                      <v-card
                        title="Trips"
                        style="border-radius: 0px; height: 300px; overflow-y: auto;"
                      >
                        <v-card-text style="padding: 5px 15px 0px 10px">
                          <v-layout justify-space-between mb-3>
                            <v-flex v-if="currentTripPoints.length > 0" text-xs-left>
                              <h4 v-text="currentTime"></h4>
                            </v-flex>
                            <v-flex v-else text-xs-left>
                              <h4>Select Trip</h4>
                            </v-flex>
                            <v-flex
                              v-if="'id' in currentSelectedUser"
                              text-xs-right
                              style="text-align: right !important"
                            >
                              <v-btn @click="trackLoc(currentSelectedUser)" icon>
                                <v-icon>notification_important</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex v-if="currentTripPoints.length > 0" text-xs-right>
                              <v-icon @click="playTrip" v-if="playing">pause</v-icon>
                              <v-icon @click="playTrip" v-else>play_arrow</v-icon>
                            </v-flex>
                          </v-layout>

                          <v-slider
                            v-if="trips.length > 0"
                            v-model="currentSlider"
                            always-dirty
                            thumb-label
                            min="0"
                            max="100"
                          >
                            <template v-slot:prepend>
                              <v-icon @click="decrement">maximize</v-icon>
                            </template>

                            <template v-slot:append>
                              <v-icon @click="increment">add</v-icon>
                            </template>
                          </v-slider>
                        </v-card-text>

                        <v-list v-if="trips.length > 0" subheader two-line>
                          <v-subheader>All Trips</v-subheader>

                          <v-radio-group v-model="trip" style="margin-top: 4px !important">
                            <v-list-item
                              v-for="item in trips"
                              :key="item.id"
                              @click="selectTrip(item)"
                            >
                              <v-list-item-action>
                                <v-radio :value="item.id"></v-radio>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                <v-list-item-subtitle
                                  >Distance : {{ item.odo }} Kms</v-list-item-subtitle
                                >
                                <v-list-item-subtitle
                                  >Duration : {{ item.duration }} mins</v-list-item-subtitle
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </v-radio-group>
                        </v-list>
                        <div v-else style="padding: 40px 25px; text-align: center;">
                          <v-icon style="font-size: 60px; opacity: 0.6; margin-bottom: 20px"
                            >transfer_within_a_station</v-icon
                          >
                          <h4
                            style="font-size: 16px; letter-spacing: 0.5px; font-weight: 400; opacity: 0.6"
                          >
                            Nothing in trips
                          </h4>
                        </div>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    <!-- Form Dialog -->
    <v-dialog v-model="dialogFormResponse" max-width="600px">
      <v-card>
        <v-card-title>
          {{ responseForm.forms.name }}
          <v-spacer></v-spacer>
          <small style="float:right">{{ getName(responseForm.userId) }}</small>
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex v-for="question in responseForm.response" :key="question.id" xs12 sm6>
              <h3>{{ question.placeHolder }}</h3>

              <h4 v-if="question.fieldType == 'attachment'">
                Response:
                <a
                  :download="question.answer"
                  :href="getAttachment(question.answer)"
                  v-if="question.answer"
                  target="_blank"
                  >Download</a
                >
              </h4>

              <h4 v-else>Answer: {{ question.answer }}</h4>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialogFormResponse = false" color="primary">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogZoom" max-width="40vw" content-class="reg__boxShadowHide">
      <img :src="selectedZoomImage" @click.stop="dialogZoom = false" />
    </v-dialog>
  </v-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<script>
import blob from "blob";
import Papa from "papaparse";
//import DatePicker from "vue2-datepicker";
import moment from "moment-timezone";
import { isMobile } from "mobile-device-detect";
import { functions } from "firebase";
//import { Datetime } from "vue-datetime";
import { EventBus } from "@/utilities/event-bus.js";
//import "vue-datetime/dist/vue-datetime.css";
import VWidget from "@/components/VWidget.vue";
import VCircle from "@/components/circle/VCircle.js";
//import VuePerfectScrollbar from "vue-perfect-scrollbar";
import canSee from "@/utilities/canSee";
import GmapCustomMarker from "vue2-gmap-custom-marker";

export default {
  components: {
    VCircle,
    VWidget,
    GmapCustomMarker: GmapCustomMarker
  },
  /* components: {
    DatePicker,
    datetime: Datetime,
    VuePerfectScrollbar,
    VCircle,
    VWidget,
    GmapCustomMarker: GmapCustomMarker
  }, */
  data: () => ({
    preloader: false,
    highlightedUser: null,
    selectedZoomImage: "",
    dialogZoom: false,
    isRealTimeEnable: false,
    startTripPoint: {},
    endTripPoint: {},
    userSeletedData: "",
    playing: false,
    SelectStartDateModal: false,
    SelectEndDateModal: false,
    // startDateFieldTrackingModal : false,
    selectedTimeStart: "",
    selectedTimeEnd: "",
    // endDateFieldTrackingModal : false,
    tab: null,
    trips: [],
    trip: "",
    currentTrip: {},
    currentTripPoints: [],
    currentSlider: 100,
    currentTime: "",
    interval: null,
    exportFields: {
      Name: "name",
      Time: "timewithDate",
      Latitude: "gps.lat",
      Longitude: "gps.lng",
      Address: "address.display_name"
    },
    currentMapPointerPresent: false,
    currentMapPointer: {},
    dialogFormResponse: false,
    unsub: () => {},
    responseForm: { forms: { name: "" } },
    latLng: {
      lat: 22.2232,
      lng: 88.2232
    },
    center: {
      lat: 22.2232,
      lng: 88.2232
    },
    pointerLabel: "",
    selectedLocationId: "",
    primaryFieldUsers: [],
    noFieldData: false,
    fieldUserData: [],
    currentSelectedUser: {
      fieldTrackings: [],
      lastSeen: {
        gps: { lat: 0, lng: 0 },
        meta: { battery_level: "Loading.." }
      },
      realtimeFieldTrackingSettings: { enabled: false },
      time: "Loading.."
    },
    slider: 0,
    formResponses: [],
    forms: [],
    fieldTrackingUsers: [],
    selectedTags: {},
    userFeildMap: [],
    allUserCoordinates: [],
    isRealTimeFieldUser: false,
    punchDetails: [],
    allUsers: [],
    search: "",
    editedItem: {
      coordinates: {
        lat: 12.33,
        lng: 25.33
      }
    },
    fieldReport_fields: {
      "User Name": "name",
      Address: "address.display_name",
      "Form Response": "formResponseId"
    },
    headers: [
      {
        text: "Time",
        align: "left",
        value: "time"
      },
      {
        text: "Address",
        align: "left",
        value: "gps"
      },
      //  { text: 'Forms',align: 'left', value: 'formResponseId' },
      {
        text: "",
        align: "left",
        value: ""
      }
    ],

    // selectedTime: [
    //   moment()
    //     .subtract(5, "days")
    //     .toDate(),
    //   moment().toDate()
    // ],

    // selectedTimeStart: moment()
    //   .subtract(5, "days")
    //   .format("YYYY-MM-DDTHH:mm:ss"),

    // selectedTimeEnd: moment().format("YYYY-MM-DDTHH:mm:ss"),

    notafter: new Date(),
    shortcuts: [
      {
        text: "Last 1 Week",
        onClick: () => {
          this.selectedTime = [
            moment()
              .subtract(7, "days")
              .toDate(),
            moment().toDate()
          ];
        }
      }
    ]
  }),
  sockets: {
    connect() {}
  },

  computed: {
    records: {
      get: function() {
        if (this.$store.getters.pagination[this.$router.currentRoute.name]) {
          return this.$store.getters.pagination[this.$router.currentRoute.name];
        } else {
          return "10";
        }
      },
      set: function(val) {
        this.$store.commit("setPagination", {
          name: this.$router.currentRoute.name,
          pagination: val
        });

        //this.getPageDetails()
      }
    },

    filteredFieldTrackingUsers() {
      return _.orderBy(
        this.fieldTrackingUsers.filter(
          item =>
            item.firstName.toLowerCase().includes(this.search.toLowerCase()) ||
            item.lastName.toLowerCase().includes(this.search.toLowerCase())
        ),
        "firstName"
      );
    },
    color() {
      if (this.bpm < 100) return "indigo";
      if (this.bpm < 125) return "teal";
      if (this.bpm < 140) return "green";
      if (this.bpm < 175) return "orange";
      return "red";
    },
    animationDuration() {
      return `${60 / this.bpm}s`;
    },
    currentTripMarker() {
      // This is the selectedTrip Marker
      if (this.currentTripPoints.length <= 0) return {};

      const totalLength = this.currentTripPoints.length;
      let pos = parseInt(Number((this.currentSlider / 100) * totalLength).toFixed(0));
      if (pos == totalLength) pos--;
      this.currentTime = moment
        .utc(this.currentTripPoints[pos].time)
        .tz(this.currentSelectedUser.tz.name)
        .format("llll");
      return this.currentTripPoints[pos].gps;
    }
  },

  /* asyncComputed: {
      async lastSeenAddress() {
              var gps = this.currentSelectedUser.lastSeen.gps


              //TODO LocationIQ
              var address = await this.$http.get(this.$store.state.endpoint+`revGeocodes/code2/${gps.lat}/${gps.lng}/4931425370e9036e2dfb`)
                return address.body.display_name
        }
    }, */

  watch: {
    currentSelectedUser(newV, oldV) {
      if (
        typeof this.currentSelectedUser.lastSeen != "undefined" &&
        typeof this.currentSelectedUser.lastSeen.gps != "undefined"
      ) {
        this.center = this.currentSelectedUser.lastSeen.gps;
      }
    }
  },

  beforeDestroy() {
    this.unsub();
  },

  async created() {
    const self = this;

    self.unsub = self.$store.subscribe((mutation, state) => {
      if (
        mutation.type === "setSelectedTags" ||
        mutation.type === "setMode" ||
        mutation.type === "setGroup"
      ) {
        const opts = {
          tags: _.map(
            _.filter(state.selectedTags, t => t.type == "tag"),
            "id"
          ),
          locations: _.map(
            _.filter(state.selectedTags, t => t.type == "location"),
            "id"
          ),
          mode: state.mode,
          group: state.group
        };
        self.updateTagAndLocation(opts);
      }
    });

    self.updateTagAndLocation(this.$store.getters.getSelectedTagsAndLocations);

    this.$http
      .get(
        `${this.$store.state.endpoint}Accounts?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
      )
      .then(
        response => {
          this.allUsers = response.body;
        },
        error => {
          console.log(error);
        }
      );

    this.getForms();

    // get all form response
    this.$http
      .get(
        `${this.$store.state.endpoint}formResponses?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
      )
      .then(
        response => {
          this.formResponses = response.body;
        },
        error => {
          console.log(error);
        }
      );

    // Setup a listner for realtime updates
    await this.sockets.unsubscribe(this.$store.state.userDetails.companyId);

    this.sockets.subscribe(this.$store.state.userDetails.companyId, realtimeUpdate => {
      // Update my users
      for (const x in self.fieldTrackingUsers) {
        if (self.fieldTrackingUsers[x].id == realtimeUpdate.userId) {
          self.fieldTrackingUsers[x].lastSeen = realtimeUpdate;
          self.fieldTrackingUsers[x].distance = realtimeUpdate.odo;

          if (realtimeUpdate.userId == self.currentSelectedUser.id) {
            self.currentSelectedUser.lastSeen = realtimeUpdate;
          }
        }
      }
    });
    this.updateTrips();
  },
  methods: {
    trackLoc(item) {
      var userId = item.id;

      if ("id" in this.currentSelectedUser) {
        this.$http
          .post(this.$store.state.endpoint + "accounts/remotecall", {
            userId: userId,
            mode: "pulse"
          })
          .then(response => {
            console.log("response after tracking locaation of the user", response);
            this.updateTagAndLocation();
          })
          .catch(e => {
            console.log(e);
          });
      } else {
        return;
      }
    },

    getUserInfo(id) {
      for (var x in this.allUsers) {
        if (this.allUsers[x].id == id) {
          return this.allUsers[x];
        }
      }
    },

    getForms() {
      this.$http
        .get(
          `${this.$store.state.endpoint}forms?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            this.forms = response.body;
          },
          error => {
            console.log(error);
          }
        );
    },

    getFormName(id) {
      console.log(this.forms);
      console.log(id);
      for (var x in this.forms) {
        if (this.forms[x].id == id) {
          return this.forms[x].name;
        }
      }
    },

    exportInCSV() {
      var data = this.currentSelectedUser.fieldTrackings;
      // minor validations
      if (data < 1) {
        this.$swal({ type: "warning", text: "No records to be exported" });
        return;
      }

      data = _.map(data, d => {
        var userDetails = this.getUserInfo(d.userId);

        var payload = {
          Name: d.name //name
        };

        console.log(d);

        // supervisor
        payload.Supervisor = this.getName(userDetails.supervisor);

        // employee code
        payload["Employee Code"] = "code" in userDetails ? userDetails.code : "";

        // email id
        payload.Email = userDetails.email;

        // latitude and Longitude
        payload.GPS = "gps" in d ? `${d.gps.lat}, ${d.gps.lng}` : "";

        // timezone
        payload.Timezone = d.timezone.name;

        // date
        payload.Date = moment(d.timewithDate).format("DD/MM/YYYY");

        // time
        payload.Time = moment(d.timewithDate).format("HH:mm");

        // address
        if (d.meta != undefined && Object.keys(d.address)) {
          payload.Address = d.address.display_name;
        }

        // form response
        if (d.formResponseId != "" || d.formResponseId != undefined) {
          var responseInfo = _.filter(this.formResponses, f => {
            return f.id == d.formResponseId;
          });

          payload["Form Name"] =
            responseInfo.length > 0 ? this.getFormName(responseInfo[0].formId) : "";
        }

        return payload;
      });

      var csv = Papa.unparse(data);

      if (this.$mq != "mobile") {
        try {
          var csvData = new Blob([csv], {
            type: "text/csv;charset=utf-8;"
          });

          var csvURL = null;
          if (navigator.msSaveBlob) {
            csvURL = navigator.msSaveBlob(csvData, "download.csv");
          } else {
            csvURL = window.URL.createObjectURL(csvData);
          }

          var tempLink = document.createElement("a");
          tempLink.href = csvURL;
          tempLink.setAttribute("download", "download.csv");
          tempLink.click();
        } catch (e) {
          console.log(e);
        }
      } else {
        window.resolveLocalFileSystemURL(cordova.file.cacheDirectory, function(dir) {
          console.log("dir", dir);
          dir.getFile(
            "export-field-report-" + new Date().getTime() + ".csv",
            {
              create: true
            },
            function(file) {
              var logOb = file;

              function writeLog(str) {
                if (!logOb) return;
                logOb.createWriter(
                  function(fileWriter) {
                    fileWriter.seek(fileWriter.length);
                    var blob = new Blob([str], {
                      type: "text/csv;charset=utf-8;"
                    });
                    fileWriter.write(blob);
                    window.plugins.socialsharing.share(null, null, logOb.nativeURL, null);
                  },
                  () => {
                    this.$swal({ type: "error", text: "Something went wrong" });
                  }
                );
              }

              writeLog(csv);
            }
          );
        });
      }
    },

    markedLocationClicked() {
      try {
        // this.$nextTick(() => {
        this.isRealTimeEnable = false;
        this.highlightedUser = null;
        // })
      } catch (e) {
        console.log(e);
      }
    },

    zoom(url) {
      var fullPath = "";

      if (url == undefined) {
        fullPath = require("@/assets/demo.png");
        //return demoImg;
      } else {
        fullPath = this.$store.state.imagePath + url;
      }

      this.dialogZoom = true;
      this.selectedZoomImage = fullPath;
    },

    playTrip() {
      if (this.playing) {
        clearInterval(this.interval);
        this.playing = false;
      } else {
        this.interval = setInterval(this.increment, 500);
        this.playing = true;
      }
    },
    updateDate(startDate, endDate) {
      this.selectedTimeStart = startDate;
      this.selectedTimeEnd = endDate;
      this.selectUser();
    },
    formResponseView(val) {
      this.$http
        .get(
          `${this.$store.state.endpoint}formResponses/${val.formResponseId}?filter[include]=forms`
        )
        .then(
          response => {
            this.responseForm = response.body;

            this.dialogFormResponse = true;
          },
          error => {
            // console.log(error);
            // error callback
            if ("error" in error.body) {
              return this.$swal({
                type: "error",
                text: "This form seems to have been removed from our records"
              });
            }
            this.$swal({
              type: "error",
              text: "Something went wrong. Try again later"
            });
          }
        );
    },
    selectTrip(item) {
      if (!item) {
        item = this.trips[0];
      }
      // set the trip
      this.trip = item.id;
      this.currentTrip = item;
      this.currentTripPoints = [];
      this.startTripPoint = {};
      this.endTripPoint = {};
      // Get points for the chose trip
      // currentTripPoints
      const self = this;
      self.$http
        .get(
          `${self.$store.state.endpoint}realTimeFieldTrackings/pointsByTrip?userId=${self.currentSelectedUser.id}&tripId=${this.trip}`
        )
        .then(response => {
          var points = response.body;
          self.currentTripPoints = points;

          self.startTripPoint = points[0].gps;
          var length = points.length - 1;
          self.endTripPoint = points[length].gps;

          if (points.length > 0) {
            if (points.length <= 1) {
              self.currentTime = moment
                .utc(self.currentTripPoints[0].time)
                .tz(this.currentSelectedUser.tz.name)
                .format("llll");
            } else {
              self.currentTime = moment
                .utc(self.currentTripPoints[points.length - 1].time)
                .tz(this.currentSelectedUser.tz.name)
                .format("llll");
            }
          } else {
            self.currentTime = "";
          }

          console.log(this.startTripPoint, this.endTripPoint, this.currentTripPoints);
          self.center = self.currentTripPoints[0].gps;
        })
        .catch(err => {
          console.log(err);
        });
    },
    updateTrips(user) {
      const self = this;

      if (!user) return;
      if (user.id == "all") return;

      self.trips = [];

      var tz = this.$store.state.userDetails.tz.name;

      var start = this.selectedTimeStart
        .set({
          hours: 0,
          minutes: 0,
          seconds: 0
        })
        .tz(tz, true)
        .clone()
        .utc()
        .format();

      var end = this.selectedTimeEnd
        .set({
          hours: 23,
          minutes: 59,
          seconds: 59
        })
        .clone()
        .tz(tz, true)
        .clone()
        .utc()
        .format();

      //const start = `${moment(this.selectedTimeStart).format("YYYY-MM-DDT00:00:01")}.000Z`;
      //const end = `${moment(this.selectedTimeEnd).format("YYYY-MM-DDT23:59:59")}.000Z`;

      var selectedUserId;
      var userTz;
      if (typeof user != "undefined") {
        selectedUserId = user.id;
        userTz = tz;
      } else {
        selectedUserId = self.currentSelectedUser.id;
        userTz = self.currentSelectedUser.tz.name;
      }

      const query = {
        where: {
          accountsId: selectedUserId,
          createdOn: {
            gte: start,
            lt: end
          }
        }
      };

      var url = `${this.$store.state.endpoint}trips?filter[where][accountsId]=${selectedUserId}&filter[where][createdOn][between][0]=${start}&filter[where][createdOn][between][1]=${end}&filter[order]=createdOn desc`;
      if (typeof selectedUserId === "undefined") return;

      this.$http
        .get(
          url
          // `${this.$store.state.endpoint}trips?filter=${encodeURIComponent(JSON.stringify(query))}`
        )
        .then(response => {
          let trips = response.body;

          if (trips.length > 0) {
            trips = _.map(trips, t => {
              //Converting timezone
              t.createdOn = moment.utc(t.createdOn).tz(userTz);
              if (t.stopped) t.stoppedAt = moment.utc(t.stoppedAt).tz(userTz);

              t.name = `${moment
                .utc(t.createdOn)
                .tz(userTz)
                .format("llll")}`;
              t.odo = t.odo / 1000;

              // var createdOn = moment(t.createdOn).format();
              // var stoppedAt = moment(t.stoppedAt).format();

              if (t.stopped) {
                t.duration = moment(t.stoppedAt).diff(moment(t.createdOn), "minutes");
              } else {
                t.duration = moment().diff(moment(t.createdOn), "minutes");
              }

              return t;
            });

            trips = _.orderBy(trips, o => new moment(o.createdOn), ["desc"]);
            self.trips = trips;
            if (self.trip == "") self.trip = trips[0].id;
            self.selectTrip();
          } else {
            self.trips = [];
          }
        });
    },

    decrement() {
      this.currentSlider--;
    },
    increment() {
      this.currentSlider++;
      if (this.currentSlider >= 100 && this.playing) {
        clearInterval(this.interval);
        this.playing = false;
        this.currentSlider = 100;
      }
    },
    toggle() {
      this.isPlaying = !this.isPlaying;
    },

    calculateDistance(meter) {
      return `${meter / 1000} Km`;
    },

    calculateBattery(level) {
      return `${level * 100}%`;
    },

    statusColor(item) {
      if (item.id == "all") return "";

      if (typeof item.lastSeen !== "undefined" && typeof item.lastSeen.time !== "undefined") {
        const diff = moment().diff(item.lastSeen.time, "seconds");
        if (diff > 120) return "red";
        if (diff <= 120) return "green";
        return "";
      }
      return "";
    },
    handleClick: e => {},
    highlightPointer(pointer) {
      this.center = {};

      if (pointer.lastSeen) {
        this.center = pointer.lastSeen.gps;
      } else {
        this.center = pointer.gps;
      }

      this.highlightedUser = pointer;
    },

    getAttachment(src) {
      return this.$store.state.attachmentPath + src;
    },

    randomAvatarColor(item) {
      return item.users.length === 1
        ? ""
        : Util.randomElement(["blue", "indigo", "success", "error", "pink"]);
    },

    chatStatusColor(item) {
      return Util.randomElement(["blue", "indigo", "success", "error", "pink"]);
    },

    firstLetter(title) {
      return title.charAt(0);
    },

    canSee(what, role, options) {
      return canSee(this, what, role, options);
    },
    getName(value) {
      const userData = this.allUsers;

      for (const o in userData) {
        if (userData[o].id == value) {
          return `${userData[o].firstName} ${userData[o].lastName}`;
        }
      }
    },

    async updateTagAndLocation(tags) {
      if (typeof tags !== "undefined") this.selectedTags = tags;

      const self = this;
      self.fieldTrackingUsers = [];

      console.log(this.selectedTags);

      await this.$http
        .post(`${this.$store.state.endpoint}Accounts/byFilter`, {
          tags: this.selectedTags.tags,
          locations: this.selectedTags.locations,
          groupId: this.selectedTags.group,
          mode: this.selectedTags.mode,
          include: "supervisorDetails"
        })
        .then(
          response => {
            self.fieldTrackingUsers = [];

            var response = response.body;

            console.log(response);

            for (const m in response) {
              if (
                (typeof response[m].fieldTrackingSettings !== "undefined" &&
                  response[m].fieldTrackingSettings.enabled == true) ||
                response[m].realtimeFieldTrackingSettings.enabled == true
              ) {
                response[m].fieldTrackings = [];
                response[m].lastSeen = {};
                response[m].status = "ft";
                response[m].fullName = response[m].firstName + " " + response[m].lastName;
                self.fieldTrackingUsers.push(response[m]);
              }
            }

            if (self.canSee("filter")) {
              const allObj = {
                id: "all",
                firstName: "All ",
                lastName: "Members",
                fullName: "All Members",
                fieldTrackings: [],
                lastSeen: {},
                fieldTrackingSettings: { enabled: false },
                realtimeFieldTrackingSettings: { enabled: false }
              };
              self.fieldTrackingUsers.push(allObj);
            }

            // Now lets get the last seen of the users if they are field tracking

            for (const x in self.fieldTrackingUsers) {
              const user = self.fieldTrackingUsers[x];
              self.updateLastSeen(user);
            }
          },
          error => {
            console.log(error);
            // error callback
          }
        );

      // this.selectedUser(this.fieldTrackingUsers[0])
    },

    timeFormat(value, formatType) {
      if (formatType == "hours") {
        return moment(value).format("llll");
      }
      if (formatType == "days") {
        return moment(value).format("dddd, MMMM Do YYYY");
      }
      return moment(value).format("mm:ss");
    },

    getImage(src, small) {
      if (src == undefined) {
        const demoImg = require("@/assets/demo.png");
        return demoImg;
      }

      if (small) {
        src = src.insert(src.lastIndexOf("."), "_200x200");
      }
      return this.$store.state.imagePath + src;
    },

    renderedCSS() {
      return [
        {
          "border-radius": "50px"
        }
      ];
    },

    getUserName(value) {
      if (value == "all") return "All Members";
      const self = this;
      const userData = self.fieldTrackingUsers;

      for (const o in userData) {
        if (userData[o].id == value) {
          return `${userData[o].firstName} ${userData[o].lastName}`;
        }
      }
    },

    async updateLastSeen(user) {
      const self = this;

      // check if user has both realtime and

      if (user.id == "all") {
        return;
      }

      /* if (
        typeof user.realtimeFieldTrackingSettings !== "undefined" &&
        user.realtimeFieldTrackingSettings.enabled &&
        typeof user.fieldTrackingSettings !== "undefined" &&
        user.fieldTrackingSettings.enabled
      )*/ if (
        true
      ) {
        // If both realtime and ft are enabled
        try {
          var realLastSeen = await self.$http.get(
            `${self.$store.state.realtimeEndpoint}/lastseen/${user.companyId}${user.id}`
          );

          realLastSeen = realLastSeen.body;
        } catch (e) {
          var realLastSeen = false;
        }

        try {
          var ftLastSeen = await self.$http.get(
            `${
              self.$store.state.endpoint
            }fieldTrackings?&filter[order]=time desc&filter[limit]=1&filter[where][userId]=${encodeURIComponent(
              user.id
            )}`
          );

          ftLastSeen = ftLastSeen.body[0];
        } catch (e) {
          var ftLastSeen = false;
        }

        var finalLastSeen = {};

        if (realLastSeen && ftLastSeen) {
          if (
            moment(ftLastSeen.time)
              .utcOffset(ftLastSeen.timezone.offset)
              .isAfter(moment.utc(realLastSeen.time))
          ) {
            finalLastSeen = ftLastSeen;
          } else {
            finalLastSeen = realLastSeen;
          }
        } else if (ftLastSeen) {
          finalLastSeen = ftLastSeen;
        } else if (realLastSeen) {
          finalLastSeen = realLastSeen;
        } else {
          finalLastSeen = {};
        }

        if (finalLastSeen.time) {
          finalLastSeen.time = moment.utc(finalLastSeen.time).tz(user.tz.name);
        }

        _.each(
          self.fieldTrackingUsers,
          function(o) {
            if (o.id == this.user.id) {
              o.lastSeen = finalLastSeen;
            }
          }.bind({ user: user })
        );
      } else if (
        (typeof user.realtimeFieldTrackingSettings !== "undefined" ||
          user.realtimeFieldTrackingSettings.enabled) &&
        (typeof user.fieldTrackingSettings === "undefined" || !user.fieldTrackingSettings.enabled)
      ) {
        self.$http
          .get(`${self.$store.state.realtimeEndpoint}/lastseen/${user.companyId}${user.id}`)
          .then(
            function(last) {
              _.each(
                self.fieldTrackingUsers,
                function(o) {
                  if (o.id == this.user.id) {
                    o.lastSeen = last.body;
                  }
                }.bind({ user: this.user })
              );
            }.bind({ user })
          )
          .catch(err => {});
      } else {
        self.$http
          .get(
            `${self.$store.state.endpoint}fieldTrackings?filter[where][userId]=${user.id}&filter[order]=time desc&filter[limit]=1`
          )
          .then(
            function(last) {
              _.each(
                self.fieldTrackingUsers,
                function(o) {
                  if (o.id == this.user.id) {
                    o.lastSeen = last.body[0];
                  }
                }.bind({ user: this.user })
              );
            }.bind({ user })
          )
          .catch(err => {});
      }
    },

    selectUser(user) {
      this.preloader = true;
      const self = this;

      if (user) {
        self.currentSelectedUser = user;
      } else {
        user = self.currentSelectedUser;
      }

      this.punchDetails = [];
      self.currentSelectedUser.fieldTrackings = [];

      //const start = `${moment(this.selectedTimeStart).format("YYYY-MM-DDT00:00:01")}.000Z`;
      //const end = `${moment(this.selectedTimeEnd).format("YYYY-MM-DDT23:59:59")}.000Z`;

      var tz = this.$store.state.userDetails.tz.name;

      var start = this.selectedTimeStart
        .set({
          hours: 0,
          minutes: 0,
          seconds: 0
        })
        .tz(tz, true)
        .clone()
        .utc()
        .format();
      //console.log("Incp=oming ", this.selectedTimeEnd.format(), tz);
      var end = this.selectedTimeEnd
        .set({
          hours: 23,
          minutes: 59,
          seconds: 59
        })
        .clone()
        .tz(tz, true)
        .clone()
        .utc()
        .format();

      // Get Field Tracking Data and Populate Map pointers and Populate List

      let url = "";

      if (user.id == "all") {
        self.currentSelectedUser.fieldTrackings = [];
        const filter = {
          where: {
            userId: {
              inq: _.map(
                _.filter(_.map(self.fieldTrackingUsers, "id"), i => {
                  return i != "all";
                }),
                item => {
                  return `${item}`;
                }
              )
            },
            time: {
              gte: start,
              lt: end
            }
          },
          order: "time desc"
        };

        url = `fieldTrackings?filter=${encodeURIComponent(JSON.stringify(filter))}`;
      } else {
        url = `fieldTrackings?filter[where][userId]=${user.id}&filter[where][time][between][0]=${start}&filter[where][time][between][1]=${end}&filter[order]=time desc`;
      }

      this.$http.get(this.$store.state.endpoint + url).then(
        response => {
          _.each(self.fieldTrackingUsers, o => {
            o.fieldTrackings = [];
          });

          self.punchDetails = [];
          self.currentSelectedUser.fieldTrackings = [];

          for (var x in response.body) {
            const time = moment.tz(response.body[x].time, response.body[x].timezone.name);
            if (response.body[x].time == "") {
              response.body[x].time = "";
            } else {
              response.body[x].time = time;
            }

            response.body[x].timewithDate = self.timeFormat(response.body[x].time, "hours");

            response.body[x].name = self.getUserName(response.body[x].userId);
          }

          for (var x in response.body) {
            for (var y in self.fieldTrackingUsers) {
              if (self.fieldTrackingUsers[y].id == response.body[x].userId) {
                self.fieldTrackingUsers[y].fieldTrackings.push(response.body[x]);
              }
            }
          }

          if (user.id == "all") {
            self.currentSelectedUser.fieldTrackings = [];

            const allFieldTrackings = [];
            _.each(self.fieldTrackingUsers, o => {
              _.each(o.fieldTrackings, u => {
                allFieldTrackings.push(u);
              });
            });

            self.currentSelectedUser = {
              id: "all",
              firstName: "All ",
              lastName: "Members",
              fieldTrackings: allFieldTrackings,
              fieldTrackingSettings: { enabled: false },
              realtimeFieldTrackingSettings: { enabled: false },

              lastSeen: {
                time: "",
                meta: { battery_level: "Loading.." }
                // gps: { lat: 0, lng: 0 }
              }
            };
          } else {
            //    self.currentSelectedUser.fieldTrackings =  response.body

            self.updateLastSeen(self.currentSelectedUser);
          }

          self.highlightedUser = null;
          self.updateTrips(user);
          // self.getTrackData()
          this.preloader = false;
        },
        error => {
          console.log(error);
          this.preloader = false;
        }
      );
    }
  }
};
</script>

<style>
h1,
/* h2 {
  font-weight: normal;
} */
  
ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

/* a {
  color: #42b983;
} */
@keyframes metronome-example {
  from {
    transform: scale(0.5);
  }

  to {
    transform: scale(1);
  }
}

.v-avatar--metronome {
  animation-name: metronome-example;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
.v-card .v-sheet {
  border-radius: 0px !important;
}
.marker_img_background {
  width: 36px;
  height: 36px;
  border: 2px solid rgb(35, 91, 212);
  background: rgb(35, 91, 212);
  border-radius: 50% 50% 50% 0;
  /* position: absolute; */
  animation-name: bounce;
  animation-fill-mode: both;
  animation-duration: 1s;
  transform: rotate(-45deg);
  /* left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px; */
}
.marker_img_render {
  width: 27px;
  height: 26px;
  border-radius: 50% 50% 50% 50%;
  position: absolute;
  /* animation-name: bounceMarker; */
  animation-fill-mode: both;
  animation-duration: 1s;
  /* left: 50%; */
  transform: rotate(45deg);
  /* top: 50%;? */
  margin: 2.8px;
}

.pulse {
  background: transparent;
  border-radius: 50%;
  height: 14px;
  width: 14px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: 0px 0px 0px -20px;
  transform: rotateX(55deg);
  z-index: -2;
}
.pulse:after {
  content: "";
  border-radius: 50%;
  height: 40px;
  width: 40px;
  position: absolute;
  /* margin: -13px 0 0 0px; */
  animation: pulsate 1s ease-out;
  animation-iteration-count: infinite;
  opacity: 0;
  box-shadow: 0 0 1px 2px #006de9;
  animation-delay: 1.1s;
}

.pulse_ft {
  background: transparent;
  border-radius: 50%;
  height: 14px;
  width: 14px;
  position: absolute;
  /* left: 50%; */
  /* top: 50%; */
  margin: -8px 0px 0px -3px;
  transform: rotateX(55deg);
  z-index: -2;
}

.pulse_ft:after {
  content: "";
  border-radius: 50%;
  height: 40px;
  width: 40px;
  position: absolute;
  /* margin: -13px 0 0 0px; */
  animation: pulsate 1s ease-out;
  animation-iteration-count: infinite;
  opacity: 0;
  box-shadow: 0 0 1px 2px #006de9;
  animation-delay: 1.1s;
}

@keyframes pulsate {
  0% {
    transform: scale(0.1, 0.1);
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    transform: scale(1.2, 1.2);
    opacity: 0;
  }
}

.ft_marker_img_render {
  width: 40px;
  height: 40px;
  border-radius: 50% 50% 50% 50%;
  /* position: absolute; */
  animation-name: bounce;
  animation-fill-mode: both;
  animation-duration: 1s;
  /* animation: bounce 1s both */
  transform: rotate(0deg);
  /* left: 50%;
  top: 50%;  */
}

.selected_ft_marker_img_render {
  width: 40px;
  height: 40px;
  border-radius: 50% 50% 50% 50%;
  /* position: absolute; */
}

.form_response_h4 {
  font-size: 14px;
  color: #292929;
}
.form_response_h3 {
  font-size: 15px;
  font-weight: 500;
  color: #292929;
  word-wrap: break-all !important;
}
.form_response_title_h3 {
  font-size: 18px;
  letter-spacing: 0.5px;
  font-weight: 600;
  color: #292929;
  word-wrap: break-all !important;
}
.selectedUser {
  background-color: #ebebeb;
}

.betaDesign {
  font-size: 10px;
  padding: 0px 0px 15px 2px;
  font-weight: 400;
}
.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes)
  .v-slide-group__prev {
  display: none !important;
}
</style>
